<e-dialog [open]="open()" (openChange)="open.set($event)" [title]="title()">
  <ng-template>
    <!--
      ng-select met appendTo="body" i.p.v. e-dropdown-menu: een in-place menu
      verdwijnt achter de scroll-clipping van mat-dialog-content (zie de
      dialogs-caveat in AGENTS.md); het ng-select-paneel zweeft boven de dialog.
    -->
    <div class="game-dialog-body">
      <div class="game-dialog-row">
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="gamepad"
          data-test-id="dialog-game-mode"
          [color]="gameMode() ? 'primary-75' : 'highlight'"
          [iconColor]="gameMode() ? undefined : 'primary-75'"
          [tooltip]="t('humanDesign.chart.controls.tooltips.gameModeToggle')"
          (click)="gameModeToggled.emit()"
        ></button>

        @if (gameMode()) {
          <ng-select
            class="game-dropdown"
            data-test-id="dialog-game-select"
            appendTo="body"
            [items]="gameOptions()"
            bindLabel="label"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            [disabled]="gameActive()"
            [ngModel]="selectedGameId()"
            (ngModelChange)="gameSelectionChange.emit($event)"
            [attr.tooltip]="t('humanDesign.chart.controls.tooltips.game')"
          ></ng-select>

          @if (hasGameVariants()) {
            <ng-select
              class="game-dropdown"
              data-test-id="dialog-game-variant-select"
              appendTo="body"
              [items]="selectedGameOption().variants"
              bindLabel="label"
              bindValue="id"
              [clearable]="false"
              [searchable]="false"
              [disabled]="gameActive()"
              [ngModel]="selectedGameVariantId()"
              (ngModelChange)="gameVariantChange.emit($event)"
              [placeholder]="t('humanDesign.chart.controls.fallback.variant')"
              [attr.tooltip]="t('humanDesign.chart.controls.tooltips.gameVariant')"
            ></ng-select>
          }

          @if (showGateRangeControls()) {
            <button
              eBtn
              size="sm"
              squared
              type="button"
              icon="list-ol"
              [color]="gateRangeSortEnabled() ? 'primary-75' : 'highlight'"
              [iconColor]="gateRangeSortEnabled() ? undefined : 'primary-75'"
              [tooltip]="t('humanDesign.chart.controls.tooltips.sortGates')"
              [disabled]="gameActive()"
              (click)="gateRangeSortToggled.emit()"
            ></button>

            @if (gateRangeSortEnabled()) {
              <ng-select
                class="game-dropdown game-dropdown-narrow"
                data-test-id="dialog-gate-range-start-select"
                appendTo="body"
                [items]="gateRangeStartOptions()"
                bindLabel="label"
                bindValue="id"
                [clearable]="false"
                [disabled]="gameActive()"
                [ngModel]="gateRangeStart()"
                (ngModelChange)="gateRangeStartChange.emit($event)"
                [attr.tooltip]="t('humanDesign.chart.controls.tooltips.startGate')"
              ></ng-select>

              <ng-select
                class="game-dropdown game-dropdown-narrow"
                data-test-id="dialog-gate-range-end-select"
                appendTo="body"
                [items]="gateRangeEndOptions()"
                bindLabel="label"
                bindValue="id"
                [clearable]="false"
                [disabled]="gameActive()"
                [ngModel]="gateRangeEnd()"
                (ngModelChange)="gateRangeEndChange.emit($event)"
                [attr.tooltip]="t('humanDesign.chart.controls.tooltips.endGate')"
              ></ng-select>
            }
          }

          @if (showDrawChartControls()) {
            <ng-select
              class="game-dropdown"
              data-test-id="dialog-draw-chart-select"
              appendTo="body"
              [items]="drawChartTargets()"
              [loading]="drawChartTargetsLoading()"
              bindLabel="name"
              bindValue="id"
              [clearable]="false"
              [disabled]="gameActive()"
              [ngModel]="drawChartTargetId()"
              (ngModelChange)="drawChartTargetChange.emit($event)"
              [placeholder]="t('humanDesign.chart.controls.fallback.chooseChart')"
              [attr.tooltip]="t('humanDesign.chart.controls.tooltips.chooseDrawChart')"
            ></ng-select>
          }

          @if (!gameActive()) {
            <button
              eBtn
              size="sm"
              squared
              type="button"
              color="highlight"
              icon="play"
              iconColor="success"
              data-test-id="dialog-play"
              [tooltip]="t('humanDesign.chart.controls.tooltips.startGameShort')"
              (click)="onPlayClicked()"
            ></button>
          } @else {
            <button
              eBtn
              size="sm"
              squared
              type="button"
              color="highlight"
              icon="stop"
              iconColor="danger"
              data-test-id="dialog-stop"
              [tooltip]="t('humanDesign.chart.controls.tooltips.stopGameShort')"
              (click)="stopRequested.emit()"
            ></button>
          }
        }
      </div>
    </div>
  </ng-template>
</e-dialog>
